import { MonitoringService, SharedUserService, UserServiceModel } from '@agroone-front/shared'
import { UserRules } from '@agroone/business'
import { Languages, Profil, UserDto } from '@agroone/entities'
import { Injectable, inject } from '@angular/core'
import { environment } from '@front-app-environments/environment'
import { TranslateService } from '@ngx-translate/core'
import { Observable } from 'rxjs'
@Injectable({
  providedIn: 'root',
})
export class UserService extends SharedUserService implements UserServiceModel {
  private readonly translate = inject(TranslateService)
  private readonly monitoringService = inject(MonitoringService)

  private readonly _allowedProfilesToCreateNotifications: Profil[] = [Profil.MANAGER, Profil.TECHNICIAN, Profil.SCOUT]
  public override readonly userApiUrl: string = `${environment.apiUrl}${environment.users}`

  public override init(): Observable<UserDto> {
    this.user.subscribe((user) => {
      if (user) {
        const dateFormat = UserRules.getDateFormatForLanguage(user.language)
        this.currentUserDateFormat = dateFormat
        // e.g. 'dd/MM/yy HH:mm' is no DateFormat member: the shared setter type is too narrow
        this.currentUserDateHourFormat = (dateFormat + ' HH:mm') as any

        this._setLanguage(user.language)

        this.monitoringService.identifyUser(user.email)
        const profil = this.requireCurrentUser().profil
        this.userCanUseNotificationFeature =
          profil !== undefined && this._allowedProfilesToCreateNotifications.includes(profil)
      } else {
        const browserLanguage = window.navigator.language.split('-')?.[0] || 'en'
        const matchingLanguage =
          Object.values(Languages).find((lang) => lang.startsWith(browserLanguage)) || Languages['en-us']
        this._setLanguage(matchingLanguage)
      }
    })
    return this.getCurrentUser()
  }

  private _setLanguage(language: string) {
    localStorage.setItem('userLanguage', language)
    this.translate.setFallbackLang(language)
    this.translate.use(language)
  }
}
